import React, { Component, Fragment, PureComponent } from 'react';
import ModalDialog from '../../../../common/ModalDialog';
import DocAssistComp from '../DocAssistComp';
import { connect } from 'react-redux';
import { GlobalState } from '../../../../../store/reducers';
import { getPatient } from '../../../../../store/selectors/prescriptionPad';
import { getItemFromMisc } from '../../../../../store/idbHandler';
import { GenieSettings, SREV2 } from '../../../../../api/pushGenie';
import { getMActiveId } from '../../../../../store/localstorage';
import { getAclViewClassName } from '../../../../../restrictions/utils';

type State = {
    isDialogOpen: boolean;
    meetDocAssistDisabled: boolean;
};

type Props = {
    docid: string;
};

export class AskAssist extends PureComponent<Props, State> {
    state: State = {
        isDialogOpen: false,
        meetDocAssistDisabled: false,
    };

    componentDidMount = async () => {
        const { meetDocAssistDisabled } = await getItemFromMisc<GenieSettings>(
            getMActiveId() || '',
            'settings',
        );
        this.setState({ meetDocAssistDisabled: meetDocAssistDisabled });
    };

    openDialog = () => {
        this.setState({ isDialogOpen: true });
    };

    closeDialog = () => {
        this.setState({ isDialogOpen: false });
    };

    render() {
        const { isDialogOpen, meetDocAssistDisabled } = this.state;

        if (meetDocAssistDisabled) return null;

        const { docid } = this.props;

        return (
            <Fragment>
                <button
                    onClick={this.openDialog}
                    className={`relative px-10 py-10 lg:py-8 btn--small primary-btn-v2 ${getAclViewClassName(
                        SREV2.DOC_ASSIST,
                    )}`}
                >
                    <div className="flex items-center justify-center w-16 h-16">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                        >
                            <g style={{ mixBlendMode: 'multiply' }}>
                                <circle
                                    cx="8.61533"
                                    cy="8.07602"
                                    r="5.38462"
                                    fill="#215FFF"
                                ></circle>
                            </g>
                            <g filter="url(#filter0_b_45_2979)">
                                <circle
                                    cx="3.76923"
                                    cy="3.76923"
                                    r="3.76923"
                                    fill="#B45EDC"
                                    fill-opacity="0.6"
                                ></circle>
                            </g>
                            <defs>
                                <filter
                                    id="filter0_b_45_2979"
                                    x="-1.07692"
                                    y="-1.07692"
                                    width="9.69242"
                                    height="9.69291"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                >
                                    <feFlood
                                        flood-opacity="0"
                                        result="BackgroundImageFix"
                                    ></feFlood>
                                    <feGaussianBlur
                                        in="BackgroundImageFix"
                                        stdDeviation="0.538462"
                                    ></feGaussianBlur>
                                    <feComposite
                                        in2="SourceAlpha"
                                        operator="in"
                                        result="effect1_backgroundBlur_45_2979"
                                    ></feComposite>
                                    <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="effect1_backgroundBlur_45_2979"
                                        result="shape"
                                    ></feBlend>
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <p className="hidden lg:flex lg:min-w-108 select-none">Ask DocAssist AI</p>
                </button>

                {isDialogOpen && (
                    <ModalDialog>
                        <DocAssistComp closeMe={this.closeDialog} docid={docid} />
                    </ModalDialog>
                )}
            </Fragment>
        );
    }
}

export default connect((state: GlobalState) => ({
    patient: getPatient(state),
}))(AskAssist);
